import store from '@/store'

/**
 * Opciones para la pantalla de carga
 */
export interface LoadinScreenConfig {
    /**
     * Muestra la pantalla de carga ocupando todo el ancho y alto del espacio
     * visible
     */
    fullscreen?: boolean

    /**
     * Si se activa, sustituye el mensaje argumentado y muestra el logotipo
     * de Prologue junto con un indicado de carga
     */
    brand?: boolean

    /**
     * Si se activa, mostrará una barra de progreso con un valor a 0
     */
    determinate?: boolean
}

/**
 * Pantalla de carga
 *
 * Pequeña clase de utilidad que permite controlar la pantalla de carga de la
 * aplicación.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class LoadingScreen {

    /**
     * Muestra la pantalla de carga
     *
     * @param message Mensaje a mostrar
     */
    public static show (message: string, config: LoadinScreenConfig = {}) {
        store.commit('showLoadingScreen', { message, ...config })
    }

    /**
     * Oculta la pantalla de carga
     */
    public static hide () {
        store.commit('hideLoadingScreen')
    }

    /**
     * Modifica el progreso actual mostrado en la pantalla de carga si existe alguno
     *
     * @param qt
     * @param global
     */
    public static progress (progress: number, message = '', global = false) {
        // La pantalla de carga no es visible ni se ha activado el progreso
        // determinado, se detiene el progreso
        if (!store.state.loadingScreen.visible || !store.state.loadingScreen.determinate) {
            return
        }

        store.commit('setLoadingScreenProgress', { progress, global})
        if (message) {
            store.commit('setLoadingScreenProgressMessage', message)
        }
    }
}
